const NavArrow = () => {
  return (
    <svg
      width="5"
      height="8"
      viewBox="0 0 5 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.824219 0.5L4.32422 4L0.824219 7.5L0.00390625 6.67969L2.68359 4L0.00390625 1.32031L0.824219 0.5Z"
        fill="#707070"
      />
    </svg>
  );
};

export default NavArrow;
